
import { useBusinessDataFetcher } from './business/useBusinessDataFetcher';
import { useBusinessStateManager } from './business/useBusinessStateManager';
import { useBusinessDataSaver } from './business/useBusinessDataSaver';
import { BusinessData } from '@/api/business/types';

export const useBusinessSettings = () => {
  const { 
    businessData, 
    setBusinessData, 
    isLoading, 
    authError 
  } = useBusinessDataFetcher();
  
  const {
    isDirty,
    setIsDirty,
    isSaving,
    setIsSaving,
    updateBusinessData,
    updateMultipleFields
  } = useBusinessStateManager(businessData, setBusinessData);
  
  const { handleSave } = useBusinessDataSaver(businessData, setIsSaving, setIsDirty);
  
  return {
    isLoading,
    businessData,
    isSaving,
    isDirty,
    authError,
    updateBusinessData,
    updateMultipleFields,
    handleSave
  };
};
